<template>
  <div id="page-pwdchange" >
    <!--MainBarMenu />
    <div class="layout-content container-fluid div1">
      <HeadingUser />      
      <div class="page-pwdchange py-3" align="center"-->
        <!--div
          class="cont-form-recovery w-50 px-4 px-md-5 py-5 mt-5 mt-md-0 d-flex flex-column justify-content-center align-items-center"
        -->
        <div>
          <label class="body_regular" style="color: #263238;margin-bottom: 24px">
          📌 Recuerda que debe tener al menos 10 caracteres, una mayúscula, un número y un caracter especial ( ! . @ # $ % )</label>
                 </div> <form @submit="validatePwd" onsubmit="return false" class="recovery-form">
            <div>

                <div class="baseline_box"  id="baseline_boxpwdCurrent">
                  <input :type="type"
                  v-model="pwdCurrent"
                  aria-describedby="numberHelp"
                  required
                  autocomplete="off"
                  id="inputpwdCurrent"  
                  class="input-text"
                  @click="changeborderpwdCurrent(true)"
                  @blur="changeborderpwdCurrent(false)" 
                  placeholder="Contraseña actual " />
                  <label  class="label-helper"  for="inputpwdCurrent">Contraseña actual</label>
                  
                  <svg class="input-icon password" v-if="showpwdCurrent===false" @click="show_pwdCurrent()">  width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="20" height="20" fill="white" fill-opacity="0.01"/>
                  <path d="M10.0007 2.5C14.494 2.5 18.2324 5.73333 19.0165 10C18.2332 14.2667 14.494 17.5 10.0007 17.5C5.50736 17.5 1.76903 14.2667 0.984863 10C1.7682 5.73333 5.50736 2.5 10.0007 2.5ZM10.0007 15.8333C11.7003 15.833 13.3493 15.2557 14.6781 14.196C16.0068 13.1363 16.9364 11.6569 17.3149 10C16.9351 8.34442 16.0048 6.86667 14.6762 5.80835C13.3476 4.75004 11.6993 4.17377 10.0007 4.17377C8.30211 4.17377 6.65377 4.75004 5.32518 5.80835C3.99658 6.86667 3.06634 8.34442 2.68653 10C3.06494 11.6569 3.99459 13.1363 5.32332 14.196C6.65204 15.2557 8.30114 15.833 10.0007 15.8333ZM10.0007 13.75C9.00613 13.75 8.05231 13.3549 7.34905 12.6516C6.64578 11.9484 6.2507 10.9946 6.2507 10C6.2507 9.00544 6.64578 8.05161 7.34905 7.34835C8.05231 6.64509 9.00613 6.25 10.0007 6.25C10.9953 6.25 11.9491 6.64509 12.6523 7.34835C13.3556 8.05161 13.7507 9.00544 13.7507 10C13.7507 10.9946 13.3556 11.9484 12.6523 12.6516C11.9491 13.3549 10.9953 13.75 10.0007 13.75ZM10.0007 12.0833C10.5532 12.0833 11.0831 11.8638 11.4738 11.4731C11.8645 11.0824 12.084 10.5525 12.084 10C12.084 9.44747 11.8645 8.91756 11.4738 8.52686C11.0831 8.13616 10.5532 7.91667 10.0007 7.91667C9.44816 7.91667 8.91826 8.13616 8.52756 8.52686C8.13686 8.91756 7.91736 9.44747 7.91736 10C7.91736 10.5525 8.13686 11.0824 8.52756 11.4731C8.91826 11.8638 9.44816 12.0833 10.0007 12.0833Z" fill="#5D5FEF"/>
                  </svg>
        
                  <svg class="input-icon password" v-else @click="show_pwdCurrent()" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="24" height="24" fill="white" fill-opacity="0.01"/>
                  <path d="M17.8826 19.2971C16.1239 20.4126 14.0834 21.0034 12.0006 21.0001C6.60864 21.0001 2.12264 17.1201 1.18164 12.0001C1.61167 9.67078 2.78327 7.54296 4.52164 5.93407L2.10043 3.51517C1.70958 3.1247 1.70964 2.49106 2.1003 2.10041C2.49083 1.70987 3.12423 1.70967 3.51475 2.10021L21.8993 20.4857C22.2899 20.8763 22.2897 21.5098 21.899 21.9003C21.5083 22.2906 20.8752 22.2905 20.4848 21.9L17.8826 19.2971ZM5.93564 7.35007C4.57665 8.58566 3.62996 10.2088 3.22364 12.0001C3.53593 13.3665 4.1629 14.6412 5.05464 15.7227C5.94638 16.8041 7.07827 17.6625 8.36019 18.2294C9.64212 18.7963 11.0387 19.0561 12.4387 18.9882C13.8388 18.9203 15.2036 18.5264 16.4246 17.8381L14.3966 15.8101C13.5333 16.3539 12.5108 16.5882 11.4969 16.4745C10.4829 16.3608 9.53768 15.906 8.81621 15.1845C8.09474 14.463 7.63987 13.5178 7.5262 12.5038C7.41254 11.4899 7.64682 10.4674 8.19064 9.60407L5.93564 7.35007ZM12.9146 14.3281L9.67264 11.0861C9.49471 11.539 9.45283 12.034 9.55215 12.5104C9.65146 12.9868 9.88766 13.4238 10.2318 13.7679C10.5759 14.1121 11.0129 14.3482 11.4893 14.4476C11.9657 14.5469 12.4607 14.505 12.9136 14.3271L12.9146 14.3281ZM20.8076 16.5921L19.3766 15.1621C20.0451 14.2094 20.521 13.1353 20.7776 12.0001C20.5059 10.8098 19.9949 9.68721 19.2758 8.70056C18.5567 7.71391 17.6444 6.88379 16.5945 6.26067C15.5446 5.63755 14.3789 5.23443 13.1684 5.07583C11.9578 4.91723 10.7276 5.00645 9.55264 5.33807L7.97464 3.76007C9.22164 3.27007 10.5806 3.00007 12.0006 3.00007C17.3926 3.00007 21.8786 6.88007 22.8196 12.0001C22.5132 13.6658 21.8245 15.2376 20.8076 16.5921ZM11.7236 7.50807C12.3602 7.46873 12.9978 7.56513 13.5942 7.79088C14.1906 8.01663 14.7323 8.36658 15.1832 8.81752C15.6341 9.26846 15.9841 9.81009 16.2098 10.4065C16.4356 11.003 16.532 11.6406 16.4926 12.2771L11.7236 7.50807Z" fill="#5D5FEF"/>
                  </svg>

                </div>
   
                <div class=" baseline_box" id="baseline_boxpwd">
                  <input :type="typepwd" 
                  v-model="pwd"
                  aria-describedby="numberHelp"
                  required
                  autocomplete="off"
                  id="inputpwd"   class="input-text"
                  @click="changeborderpwd(true)"
                  @blur="changeborderpwd(false)"  
                  placeholder="Nueva contraseña" />
                   <label  class="label-helper"  for="inputpwd">Nueva contraseña</label>
                 
                  <svg class="input-icon password" v-if="showpwd===false" @click="show_pwd()">  width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="20" height="20" fill="white" fill-opacity="0.01"/>
                  <path d="M10.0007 2.5C14.494 2.5 18.2324 5.73333 19.0165 10C18.2332 14.2667 14.494 17.5 10.0007 17.5C5.50736 17.5 1.76903 14.2667 0.984863 10C1.7682 5.73333 5.50736 2.5 10.0007 2.5ZM10.0007 15.8333C11.7003 15.833 13.3493 15.2557 14.6781 14.196C16.0068 13.1363 16.9364 11.6569 17.3149 10C16.9351 8.34442 16.0048 6.86667 14.6762 5.80835C13.3476 4.75004 11.6993 4.17377 10.0007 4.17377C8.30211 4.17377 6.65377 4.75004 5.32518 5.80835C3.99658 6.86667 3.06634 8.34442 2.68653 10C3.06494 11.6569 3.99459 13.1363 5.32332 14.196C6.65204 15.2557 8.30114 15.833 10.0007 15.8333ZM10.0007 13.75C9.00613 13.75 8.05231 13.3549 7.34905 12.6516C6.64578 11.9484 6.2507 10.9946 6.2507 10C6.2507 9.00544 6.64578 8.05161 7.34905 7.34835C8.05231 6.64509 9.00613 6.25 10.0007 6.25C10.9953 6.25 11.9491 6.64509 12.6523 7.34835C13.3556 8.05161 13.7507 9.00544 13.7507 10C13.7507 10.9946 13.3556 11.9484 12.6523 12.6516C11.9491 13.3549 10.9953 13.75 10.0007 13.75ZM10.0007 12.0833C10.5532 12.0833 11.0831 11.8638 11.4738 11.4731C11.8645 11.0824 12.084 10.5525 12.084 10C12.084 9.44747 11.8645 8.91756 11.4738 8.52686C11.0831 8.13616 10.5532 7.91667 10.0007 7.91667C9.44816 7.91667 8.91826 8.13616 8.52756 8.52686C8.13686 8.91756 7.91736 9.44747 7.91736 10C7.91736 10.5525 8.13686 11.0824 8.52756 11.4731C8.91826 11.8638 9.44816 12.0833 10.0007 12.0833Z" fill="#5D5FEF"/>
                  </svg>
        
                  <svg class="input-icon password" v-else @click="show_pwd()" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="24" height="24" fill="white" fill-opacity="0.01"/>
                  <path d="M17.8826 19.2971C16.1239 20.4126 14.0834 21.0034 12.0006 21.0001C6.60864 21.0001 2.12264 17.1201 1.18164 12.0001C1.61167 9.67078 2.78327 7.54296 4.52164 5.93407L2.10043 3.51517C1.70958 3.1247 1.70964 2.49106 2.1003 2.10041C2.49083 1.70987 3.12423 1.70967 3.51475 2.10021L21.8993 20.4857C22.2899 20.8763 22.2897 21.5098 21.899 21.9003C21.5083 22.2906 20.8752 22.2905 20.4848 21.9L17.8826 19.2971ZM5.93564 7.35007C4.57665 8.58566 3.62996 10.2088 3.22364 12.0001C3.53593 13.3665 4.1629 14.6412 5.05464 15.7227C5.94638 16.8041 7.07827 17.6625 8.36019 18.2294C9.64212 18.7963 11.0387 19.0561 12.4387 18.9882C13.8388 18.9203 15.2036 18.5264 16.4246 17.8381L14.3966 15.8101C13.5333 16.3539 12.5108 16.5882 11.4969 16.4745C10.4829 16.3608 9.53768 15.906 8.81621 15.1845C8.09474 14.463 7.63987 13.5178 7.5262 12.5038C7.41254 11.4899 7.64682 10.4674 8.19064 9.60407L5.93564 7.35007ZM12.9146 14.3281L9.67264 11.0861C9.49471 11.539 9.45283 12.034 9.55215 12.5104C9.65146 12.9868 9.88766 13.4238 10.2318 13.7679C10.5759 14.1121 11.0129 14.3482 11.4893 14.4476C11.9657 14.5469 12.4607 14.505 12.9136 14.3271L12.9146 14.3281ZM20.8076 16.5921L19.3766 15.1621C20.0451 14.2094 20.521 13.1353 20.7776 12.0001C20.5059 10.8098 19.9949 9.68721 19.2758 8.70056C18.5567 7.71391 17.6444 6.88379 16.5945 6.26067C15.5446 5.63755 14.3789 5.23443 13.1684 5.07583C11.9578 4.91723 10.7276 5.00645 9.55264 5.33807L7.97464 3.76007C9.22164 3.27007 10.5806 3.00007 12.0006 3.00007C17.3926 3.00007 21.8786 6.88007 22.8196 12.0001C22.5132 13.6658 21.8245 15.2376 20.8076 16.5921ZM11.7236 7.50807C12.3602 7.46873 12.9978 7.56513 13.5942 7.79088C14.1906 8.01663 14.7323 8.36658 15.1832 8.81752C15.6341 9.26846 15.9841 9.81009 16.2098 10.4065C16.4356 11.003 16.532 11.6406 16.4926 12.2771L11.7236 7.50807Z" fill="#5D5FEF"/>
                  </svg>

                
                
                </div>
   
                <div class=" baseline_box" id="baseline_boxpwd2">
                  
                  <input 
                  :type="typepwd2"
                  id="inputpwd2"   
                  class="input-text"
                  v-model="pwd2"
                  required
                  autocomplete="off"
                  @click="changeborderpwd2(true)"
                  @blur="changeborderpwd2(false)"    
                  placeholder="Confirmar contraseña " />
                  <label  class="label-helper"   for="inputpwd2">Confirmar contraseña</label>
                  <svg class="input-icon password" v-if="showpwd2===false" @click="show_pwd2()">  width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="20" height="20" fill="white" fill-opacity="0.01"/>
                  <path d="M10.0007 2.5C14.494 2.5 18.2324 5.73333 19.0165 10C18.2332 14.2667 14.494 17.5 10.0007 17.5C5.50736 17.5 1.76903 14.2667 0.984863 10C1.7682 5.73333 5.50736 2.5 10.0007 2.5ZM10.0007 15.8333C11.7003 15.833 13.3493 15.2557 14.6781 14.196C16.0068 13.1363 16.9364 11.6569 17.3149 10C16.9351 8.34442 16.0048 6.86667 14.6762 5.80835C13.3476 4.75004 11.6993 4.17377 10.0007 4.17377C8.30211 4.17377 6.65377 4.75004 5.32518 5.80835C3.99658 6.86667 3.06634 8.34442 2.68653 10C3.06494 11.6569 3.99459 13.1363 5.32332 14.196C6.65204 15.2557 8.30114 15.833 10.0007 15.8333ZM10.0007 13.75C9.00613 13.75 8.05231 13.3549 7.34905 12.6516C6.64578 11.9484 6.2507 10.9946 6.2507 10C6.2507 9.00544 6.64578 8.05161 7.34905 7.34835C8.05231 6.64509 9.00613 6.25 10.0007 6.25C10.9953 6.25 11.9491 6.64509 12.6523 7.34835C13.3556 8.05161 13.7507 9.00544 13.7507 10C13.7507 10.9946 13.3556 11.9484 12.6523 12.6516C11.9491 13.3549 10.9953 13.75 10.0007 13.75ZM10.0007 12.0833C10.5532 12.0833 11.0831 11.8638 11.4738 11.4731C11.8645 11.0824 12.084 10.5525 12.084 10C12.084 9.44747 11.8645 8.91756 11.4738 8.52686C11.0831 8.13616 10.5532 7.91667 10.0007 7.91667C9.44816 7.91667 8.91826 8.13616 8.52756 8.52686C8.13686 8.91756 7.91736 9.44747 7.91736 10C7.91736 10.5525 8.13686 11.0824 8.52756 11.4731C8.91826 11.8638 9.44816 12.0833 10.0007 12.0833Z" fill="#5D5FEF"/>
                  </svg>
        
                  <svg class="input-icon password" v-else @click="show_pwd2()" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="24" height="24" fill="white" fill-opacity="0.01"/>
                  <path d="M17.8826 19.2971C16.1239 20.4126 14.0834 21.0034 12.0006 21.0001C6.60864 21.0001 2.12264 17.1201 1.18164 12.0001C1.61167 9.67078 2.78327 7.54296 4.52164 5.93407L2.10043 3.51517C1.70958 3.1247 1.70964 2.49106 2.1003 2.10041C2.49083 1.70987 3.12423 1.70967 3.51475 2.10021L21.8993 20.4857C22.2899 20.8763 22.2897 21.5098 21.899 21.9003C21.5083 22.2906 20.8752 22.2905 20.4848 21.9L17.8826 19.2971ZM5.93564 7.35007C4.57665 8.58566 3.62996 10.2088 3.22364 12.0001C3.53593 13.3665 4.1629 14.6412 5.05464 15.7227C5.94638 16.8041 7.07827 17.6625 8.36019 18.2294C9.64212 18.7963 11.0387 19.0561 12.4387 18.9882C13.8388 18.9203 15.2036 18.5264 16.4246 17.8381L14.3966 15.8101C13.5333 16.3539 12.5108 16.5882 11.4969 16.4745C10.4829 16.3608 9.53768 15.906 8.81621 15.1845C8.09474 14.463 7.63987 13.5178 7.5262 12.5038C7.41254 11.4899 7.64682 10.4674 8.19064 9.60407L5.93564 7.35007ZM12.9146 14.3281L9.67264 11.0861C9.49471 11.539 9.45283 12.034 9.55215 12.5104C9.65146 12.9868 9.88766 13.4238 10.2318 13.7679C10.5759 14.1121 11.0129 14.3482 11.4893 14.4476C11.9657 14.5469 12.4607 14.505 12.9136 14.3271L12.9146 14.3281ZM20.8076 16.5921L19.3766 15.1621C20.0451 14.2094 20.521 13.1353 20.7776 12.0001C20.5059 10.8098 19.9949 9.68721 19.2758 8.70056C18.5567 7.71391 17.6444 6.88379 16.5945 6.26067C15.5446 5.63755 14.3789 5.23443 13.1684 5.07583C11.9578 4.91723 10.7276 5.00645 9.55264 5.33807L7.97464 3.76007C9.22164 3.27007 10.5806 3.00007 12.0006 3.00007C17.3926 3.00007 21.8786 6.88007 22.8196 12.0001C22.5132 13.6658 21.8245 15.2376 20.8076 16.5921ZM11.7236 7.50807C12.3602 7.46873 12.9978 7.56513 13.5942 7.79088C14.1906 8.01663 14.7323 8.36658 15.1832 8.81752C15.6341 9.26846 15.9841 9.81009 16.2098 10.4065C16.4356 11.003 16.532 11.6406 16.4926 12.2771L11.7236 7.50807Z" fill="#5D5FEF"/>
                  </svg>

               
               
                </div>
            
            </div>


            <!--div class="form-group mb-2 ">
              <label for="inputCedula3">Actual contraseña</label>
              <input
                type="password"
                v-model="pwdCurrent"
                class="form-control"
                id="inputCedula3"
                aria-describedby="numberHelp"
                placeholder="Escribe tu actual contraseña..."
                required
                autocomplete="off"
              />
            </div>
            <div class="form-group mb-2 text-left">
              <label for="inputCedula2">Nueva contraseña</label>
              <input
                type="password"
                v-model="pwd"
                class="form-control"
                id="inputCedula2"
                aria-describedby="numberHelp"
                placeholder="Escribe tu nueva contraseña..."
                required
                autocomplete="off"
              />
            </div>
            <div class="form-group text-left">
              <label for="inputPassword">Confirmar contraseña</label>
              <input
                type="password"
                v-model="pwd2"
                class="form-control"
                id="inputPassword"
                placeholder="Confirma nueva contraseña..."
                required
                autocomplete="off"
              />
            </div>
            <button
              type="submit"
              class="btn_showPassword">
              Cambiar contraseña
            </button-->

                <button
          type="submit"
          class="btn btn_showPassword"
         
          >
          <span class="cta-small" style="color: #FFFFFF;"  > Cambiar contraseña
            </span><svg style="margin:4px; margin-left:8px" width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.96459 6.85666L13.5054 0.315826L14.6838 1.49416L13.5054 2.67333L15.5671 4.73499L14.3888 5.91416L12.3263 3.85166L11.1479 5.02999L12.9154 6.79749L11.7371 7.97666L9.96959 6.20833L8.14292 8.03499C8.70996 8.89666 8.93737 9.93798 8.78118 10.9576C8.62499 11.9772 8.09629 12.9027 7.29731 13.5551C6.49833 14.2075 5.48582 14.5405 4.45556 14.4897C3.42531 14.4389 2.45049 14.0079 1.71959 13.28C0.987108 12.5503 0.552108 11.5743 0.49913 10.5417C0.446152 9.5091 0.77898 8.49371 1.43293 7.69284C2.08688 6.89198 3.01523 6.36286 4.03755 6.20832C5.05988 6.05378 6.10314 6.28487 6.96459 6.85666ZM6.43375 12.1008C6.67652 11.8712 6.87078 11.5952 7.00507 11.2893C7.13936 10.9833 7.21094 10.6535 7.21558 10.3193C7.22023 9.98523 7.15785 9.65356 7.03212 9.34396C6.90639 9.03436 6.71988 8.7531 6.48359 8.51682C6.24731 8.28053 5.96605 8.09402 5.65645 7.96829C5.34685 7.84256 5.01519 7.78018 4.68106 7.78483C4.34694 7.78947 4.01714 7.86106 3.71115 7.99534C3.40517 8.12963 3.12921 8.3239 2.89959 8.56666C2.44419 9.03817 2.1922 9.66967 2.1979 10.3252C2.2036 10.9807 2.46652 11.6077 2.93004 12.0712C3.39356 12.5347 4.02059 12.7976 4.67608 12.8033C5.33157 12.809 5.96308 12.5571 6.43458 12.1017L6.43375 12.1008Z" fill="white"/>
</svg>
        </button>
            
          </form>
          <!--router-link to="/profile">
            <button
                type="button"
                class="mt-5 btn btn-block btn-darkblue-1">
                Volver
              </button>
          </router-link-->
          <div>
            <b-modal 
              ref="my-modal" 
              hide-footer 
              centered 
              title="Atención al mensaje:"
              no-close-on-backdrop
              @hidden="hideModal">
              <div class="d-block text-center">
                <h3>{{this.msjModal}}</h3>
              </div>
              <b-button class="mt-3" variant="outline-danger"
                block 
                @click="hideModal">
                  Cerrar
              </b-button>
            </b-modal>
          </div>
          <small v-show="error.flag" class="alert-danger">
            {{ error.message }}
          </small>
        <!--/div-->
      </div>
      <!--div class="mb-menu"></div>
    </div>
  </div-->
</template>

<script>
//import MainBarMenu from "@/components/layouts/MainBarMenu.vue";
//import HeadingUser from "@/components/user/HeadingUser.vue";
import { mapActions } from "vuex";
import serverConfig from "./../../services/config";

export default {
  name: "PwdChange",
  components: {
    //MainBarMenu,
    //HeadingUser,
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      type:'password',
      typepwd:'password',
      typepwd2:'password',
      showpwdCurrent: false,
      showpwd: false,
      showpwd2: false,
      error: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      pwdCurrent: '',
      pwd: '',
      pwd2: '',
      msjModal: '',
    }
  },
  methods: {
    ...mapActions("modCore", [
      "actPwdChange",
    ]),
    changeborderpwd(change){
      if(change){
        document.getElementById("baseline_boxpwd").style.borderColor = "#5D5FEF";
      }else{
        document.getElementById("baseline_boxpwd").style.borderColor = "#78909C";
      } 
    },
    changeborderpwd2(change){
      if(change){
        document.getElementById("baseline_boxpwd2").style.borderColor = "#5D5FEF";
      }else{
        document.getElementById("baseline_boxpwd2").style.borderColor = "#78909C";
      } 
    },
    changeborderpwdCurrent(change){
      if(change){
        document.getElementById("baseline_boxpwdCurrent").style.borderColor = "#5D5FEF";
      }else{
        document.getElementById("baseline_boxpwdCurrent").style.borderColor = "#78909C";
      } 
    },

    checkPassword(inputtxt){
      var passw= /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{10,15}$/;
      return !!inputtxt.match(passw)
    },

    async validatePwd() {
      this.error.flag = false;

      if(this.pwdCurrent.length > 0){
        if(this.pwd === this.pwd2){
          if(this.checkPassword(this.pwd)){

            let data = {
              'current_password': this.pwdCurrent,
              'new_password': this.pwd
            };

            let response = await this.actPwdChange(data);
            
            if(response.status == '500'){
              this.error.flag = true;
              this.error.class = "is-invalid";
              this.error.message = "Error: "+response.message;
            }
            
            if(response.status == '200'){
              this.showModal('La contraseña quedó actualizada',1);
            }
            //alert(JSON.stringify(response));
          }
          else{
            this.error.flag = true;
            this.error.class = "is-invalid";
            this.error.message = "La contraseña no superó el mínimo de seguridad";
          }
        }
        else{
          this.error.flag = true;
          this.error.class = "is-invalid";
          this.error.message = "Las contraseñas no coinciden, por favor rectificar";
        }
      }
      else{
        this.error.flag = true;
        this.error.class = "is-invalid";
        this.error.message = "Debe ingresar la contraseña actual";
      }      
    },

    showModal(msj,flag) {
      this.msjModal = msj;
      this.flagPath = flag;
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.$refs['my-modal'].hide()
      if(this.flagPath == 1){
        this.$router.push({ path: '/profile' });
      }
    },
    show_pwdCurrent() {
      if(this.type === 'password') {
          this.type = 'text'
          this.showpwdCurrent = true
          //this.btnText = 'Hide Password'
       } else {
          this.type = 'password'
          this.showpwdCurrent = false
          //this.btnText = ‘Show Password’
       }
   
    },
    show_pwd() {
      if(this.typepwd === 'password') {
          this.typepwd = 'text'
          this.showpwd = true
          //this.btnText = 'Hide Password'
       } else {
          this.typepwd = 'password'
          this.showpwd = false
          //this.btnText = ‘Show Password’
       }
   
    },
    show_pwd2() {
       if(this.typepwd2 === 'password') {
          this.typepwd2 = 'text'
          this.showpwd2 = true
          //this.btnText = 'Hide Password'
       } else {
          this.typepwd2 = 'password'
          this.showpwd2 = false
          //this.btnText = ‘Show Password’
       }
   
    },
   
  }
}
</script>

<style lang="scss" scoped>
#page-pwdchange {
 
   /* background-color: #1c6776;
    border-radius: 25px;

    .title {
      color: #ffffff;
      font-size: 18px;
      line-height: 18px;

      @media (min-width: 576px) {
        font-size: 18px;
        line-height: 18px;
      }
    }
    .title2 {
      color: #ffffff;
      font-size: 12px;
      line-height: 14px;

      @media (min-width: 576px) {
        font-size: 12px;
        line-height: 14px;
      }
    }
    .recovery-form {
      .form-group {
        label {
          color: #fff;
          font-size: 12px;
        }

        input[type="number"],
        input[type="password"] {
          height: 36px;
          border: 0;
          border-radius: 4px;
          outline: 0;
          font-size: 14px;

          &:focus {
            outline: 0;
          }

          &::placeholder {
            color: #bbbbbb;
            font-style: italic;
          }
        }
      }
    }

    a {
      font-size: 1.2rem;
      color: #ffffff;
    }
*/
.baseline_box{
position: relative;
margin-top: 16px;
margin-bottom: 16px;
background: #FFFFFF;
border: 1px solid #ECEFF1;
box-sizing: border-box;
border-radius: 8px;
label{
  position:absolute;
  left:4px;
  top:-8px;
  line-height:1;
  font-weight:bold;
  //display:none;

font-family: Ubuntu;
font-style: normal;
font-weight: normal;
font-size: 12px;
line-height: 16px;
color: #CFD8DC;
background: #ffffff;
flex: none;
order: 0;
flex-grow: 0;
margin: 0px 4px;
padding: 0px 4px;
}

input{
position: static;
width: 412px;
height: 28px;
left: calc(50% - 412px/2);
top: calc(50% - 28px/2);
background: #ffffff;
/* body regular */
font-family: Ubuntu;
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 28px;

/* content/03 */
color: #78909C;
/* Inside auto layout */
align-self: stretch;
flex-grow: 1;
margin: 8px;
border:0;
 &:focus, &:active {
            outline: 0;
            border:0;
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;
           box-shadow: none;
          }
}
.input-text:valid + .label-helper {
  color: #78909C;
  opacity: 1;
  }
.input-text:focus  + .label-helper ,.input-text:active + .label-helper{
   color: #5D5FEF;
  opacity: 1;
}
.input.password {
  padding: 15px 35px 15px 15px;
}

.input-icon {
  color: #191919;
  position: absolute;
  width: 20px;
  height: 20px;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
}

.input-icon.password {
  left: unset;
  right: 12px;
}

 
}
/*.btn_showPassword{
   width: 196px;
height: 28px;
background: #5D5FEF;
border-radius: 4px;
margin: 24px 0px;
    }*/

.btn_showPassword{


display: flex;
flex-direction: row;
align-items: flex-start;
padding: 4px;
padding-left:12px ;
width: 196px;
background: #5D5FEF;
border-radius: 4px;
margin-top:24px;
margin-bottom:4px;
}

.btn_showPassword:hover{
  background: #7A7CFF;
}
.btn_showPassword:active{
background: #1719DA;
}
    @media (min-width: 768px) {
     // min-height: 100%;
    }
  }

</style>